/**
 * @author Sarthak Sharma.
 * @since 02-02-2024.
 * @type {string} Media action types.
 */

export const SET_LOADING = '[RECRUITER_MEDIA] SET_LOADING';

export const SET_RECRUITER_IMAGES = '[RECRUITER_MEDIA] SET_RECRUITER_IMAGES';
export const APPEND_RECRUITER_IMAGES = '[RECRUITER_MEDIA] APPEND_RECRUITER_IMAGES';
export const SET_RECRUITER_IMAGES_META = '[RECRUITER_MEDIA] SET_RECRUITER_IMAGES_META';

export const SET_RECRUITER_VIDEOS = '[RECRUITER_MEDIA] SET_RECRUITER_VIDEOS';
export const SET_RECRUITER_VIDEOS_META = '[RECRUITER_MEDIA] SET_RECRUITER_VIDEOS_META';
export const APPEND_RECRUITER_VIDEOS = '[RECRUITER_MEDIA] APPEND_RECRUITER_VIDEOS';

export const SET_ARTIST_IMAGES = '[RECRUITER_MEDIA] SET_ARTIST_IMAGES';
export const SET_ARTIST_IMAGES_META = '[RECRUITER_MEDIA] SET_ARTIST_IMAGES_META';
export const APPEND_ARTIST_IMAGES = '[RECRUITER_MEDIA] APPEND_ARTIST_IMAGES';

export const SET_ARTIST_VIDEOS = '[RECRUITER_MEDIA] SET_ARTIST_VIDEOS';
export const SET_ARTIST_VIDEOS_META = '[RECRUITER_MEDIA] SET_ARTIST_VIDEOS_META';
export const APPEND_ARTIST_VIDEOS = '[RECRUITER_MEDIA] APPEND_ARTIST_VIDEOS';

export const SET_ARTIST_AUDIOS = '[RECRUITER_MEDIA] SET_ARTIST_AUDIOS';
export const SET_ARTIST_AUDIOS_META = '[RECRUITER_MEDIA] SET_ARTIST_AUDIOS_META';
export const APPEND_ARTIST_AUDIOS = '[RECRUITER_MEDIA] APPEND_ARTIST_AUDIOS';
